import axios from "axios";
import { AUTH_BASEURL_V1 } from "../baseUrls";

const withCookies = {
  withCredentials: true, // lets the browser accept/send the HttpOnly cookies
  headers: { "Content-Type": "application/json" },
};

class authAPI {
  async loginApi({ email, password }) {
    return axios.post(
      `${AUTH_BASEURL_V1}/auth/login`,
      { email, password },
      withCookies,
    );
  }

  async logoutApi() {
    return axios.post(
      `${AUTH_BASEURL_V1}/auth/logout`,
      {},
      withCookies,
    );
  }
}

export default authAPI;